<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" [routerLink]="['/']"></i>

        <span class="my-auto f16 fw-bold me-2"> گزارش پرداخت&zwnj;ها  </span>

    </div>

</div>

<main style="direction: rtl;" class="py-4 px-2">

    <!-- فیلتر جستجو -->

    <form class="row gx-2 gy-3" [formGroup]="mdl_Search">

        <!-- از تاریخ -->

        <div class="col-12 col-md-2 position-relative">

            <label> از تاریخ </label>
    
            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
    
                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">
    
                <input type="text" formControlName="strSDate" placeholder="از تاریخ" class="form-control text-end" />
    
            </ng-persian-datepicker>
    
        </div>

        <!-- تا تاریخ -->

        <div class="col-12 col-md-2 position-relative">

            <label> تا تاریخ </label>
    
            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
    
                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">
    
                <input formControlName="strEDate" placeholder="از تاریخ" class="form-control text-end" />
    
            </ng-persian-datepicker>
    
        </div>

        <!-- جستجو -->

        <div class="col-12 col-md-auto position-relative border border-2 b-transparent">

            <button class="btn btn-primary w-100" (click)="search_Report()"> جستجو </button>

        </div>

        <!-- خروجی اکسل -->

        <div class="col-12 col-md-auto position-relative border border-2 b-transparent">

            <button class="btn btn-success w-100" (click)="exportExcel('Export_Excel')"> 

                خروجی اکسل
                
            </button>

        </div>

    </form>

    <!-- جدول اطلاعات -->

    <div class="border border-2 mt-3 p-2" >

        <div class="row gx-0 gy-2 gy-md-0">

            <div class="col-12">

                <input class="w-100 form-control" placeholder="جستجو کنید ..." #searchTerm (keyup)="filter_list($event.target)">

            </div>

        </div>

        <div class="section border border-2 mt-2" style="height:calc(100vh - 235px);overflow: auto;">

            <table class="col-12 table table-striped rounded-3" id="Export_Excel">
    
                <thead>
            
                    <tr class="">
        
                        <th class="text-center col-1"> # </th>
    
                        <th class="text-center"> تاریخ </th>
                        
                        <th class="text-center"> ساعت  </th>

                        <th class="text-center"> کد درخواست  </th>

                        <th class="text-center"> پرداخت کننده </th>
                
                        <th class="text-center"> شماره تراکنش </th>
        
                        <th class="text-center"> کارت کد شده </th>

                        <th class="text-center"> توضیحات </th>
                        
                    </tr>
                    
                </thead>

                <tbody>

                    <tr class="col-12 text-center" *ngFor="let item of lst_Report;let i = index">

                        <th> {{ i + 1 | faNum }} </th>

                        <td> {{ item.strDate | faNum }} </td>

                        <td> {{ item.strTime | faNum }} </td>

                        <td [innerHTML]="highlightText(item.iPaymentReport.toString(),searchTerm.value)  | faNum"> </td>

                        <td [innerHTML]="highlightText(item.strFullName,searchTerm.value)  | faNum"> </td>

                        <td [innerHTML]="highlightText(item.strRefId,searchTerm.value)  | faNum"> </td>

                        <td> {{ item.strCardPan | faNum }} </td>

                        <td [innerHTML]="highlightText(item.strComment,searchTerm.value)  | faNum"> </td>

                    </tr>

                </tbody>
    
            </table>
    
        </div>

    </div>


</main>